const ToastEnums = require('../components/Toast/ToastEnums');

module.exports = {
    SAMPLE_WARNING: {
        errorCode: 1000,
        toastType: ToastEnums.WARNING,
        title: 'Warning Message!',
        message: 'Sample warning message.'
    },
    SAMPLE_INFO: {
        errorCode: 2000,
        toastType: ToastEnums.INFO,
        title: 'Info Message!',
        message: 'Sample information message.'
    },
    CLONE_ERROR: {
        errorCode: 3000,
        toastType: ToastEnums.ERROR,
        title: 'Error',
        message: 'Output node cannot be cloned.'
    },
    REMOVE_ERROR: {
        errorCode: 3001,
        toastType: ToastEnums.ERROR,
        title: 'Error',
        message: 'Output node cannot be removed.'
    },
    LOGIC_SAVED: {
        errorCode: 4000,
        toastType: ToastEnums.SUCCESS,
        title: 'Logic Saved',
        message: 'Logic successfully saved.'
    },
    LOGIC_ACTIVATED: {
        errorCode: 4000,
        toastType: ToastEnums.SUCCESS,
        title: 'Logic Activated',
        message: 'Logic successfully activated.'
    },
    LOGIC_SWITCHED: {
        errorCode: 4000,
        toastType: ToastEnums.SUCCESS,
        title: 'Logic Switched',
        message: 'Logic successfully switched.'
    },
    RENAME_SUCCESS: {
        errorCode: 4002,
        toastType: ToastEnums.SUCCESS,
        title: 'Logic Renamed',
        message: 'Logic successfully renamed.'
    },
    PAUSE_SUCCESS: {
        errorCode: 4003,
        toastType: ToastEnums.SUCCESS,
        title: 'Logic Paused',
        message: 'Logic successfully paused.'
    },
    COMPONENT_SAVE_ERROR: {
        errorCode: 3003,
        toastType: ToastEnums.ERROR,
        title: 'Component Save Error',
        message: 'Component cannot have more than one Input Items block.'
    },
    CONNECTION_ERROR: {
        errorCode: 4000,
        toastType: ToastEnums.ERROR,
        title: 'Connection Error',
        message: 'Server could not be reached.'
    },
    DUPLICATE_PROPERTY_ERROR: {
        errorCode: 4001,
        toastType: ToastEnums.ERROR,
        title: 'Duplicate Context Property',
        message: 'Context property already exists.'
    },
    CHART_CREATED: {
        errorCode: 5000,
        toastType: ToastEnums.SUCCESS,
        title: 'Chart Created',
        message: 'Chart successfully created.'
    },
    CHART_SAVED: {
        errorCode: 5001,
        toastType: ToastEnums.SUCCESS,
        title: 'Chart Saved',
        message: 'Chart successfully saved.'
    },
    CHART_DELETED: {
        errorCode: 5002,
        toastType: ToastEnums.SUCCESS,
        title: 'Chart Deleted',
        message: 'Chart successfully deleted.'
    },
    UNCONNECTED_EDGES_ERROR: {
        errorCode: 3004,
        toastType: ToastEnums.ERROR,
        title: 'Unconnected Edges Error',
        message: 'There are not connected edges.'
    },
    UNMODIFIED_NODES_ERROR: {
        errorCode: 3004,
        toastType: ToastEnums.ERROR,
        title: 'Unmodified Nodes Error',
        message: 'There are unmodified nodes.'
    },
    CUSTOM_TOAST: (title,description, type) => (
        {
            errorCode: 6000,
            toastType: `${type === 'error' ? ToastEnums.ERROR : ToastEnums.SUCCESS}`,
            title: title,
            message: description
        }
    )
};
